module.exports = __webpack_public_path__ + "static/img/lek-logo-1280x1280.c8de2e59.png";